export const conversationalToolDefinitions = "/:app_group_id/conversational/tool_definitions";
